import { useCallback, useRef } from 'react';

import CustomButton from '../../common/CustomButton/CustomButton';
import { Icon } from '../../common/Icon/Icon';
import Markdown from '../../common/Markdown/Markdown';
import NoTagRenderer from '../../common/NoTagRenderer/NoTagRenderer';
import { addBackground, slugify } from '../../core/helpers';
import useModal from '../../core/hooks/useModal';
import { IImage } from '../../core/models';
import HubSpotForm from '../HubSpotForm/HubSpotForm';
import './Mission.css';

interface IProps {
  title: string;
  desc?: string;
  form: {
    portalId?: string;
    formId?: string;
    region?: string;
    id?: string;
    btnLabel?: string;
  };
  usps: {
    title: string;
  }[];
  slug: string;
  img: IImage;
}

function Mission({ title, desc, form, slug, usps, img }: IProps) {
  const { modal, open, close } = useModal();
  const btnRef = useRef(null);

  const openModal = useCallback(() => {
    if (!btnRef.current) return;
    open(btnRef.current);
  }, [open]);

  return (
    <section className="mission" {...addBackground({ img, gradient: 'blue4' })}>
      <div className="wrap wrap--lg">
        <h2 className="mission__title h2">
          <Markdown
            components={{
              p: NoTagRenderer,
              em: 'strong',
            }}
          >
            {title}
          </Markdown>
        </h2>
        <div className="mission__container">
          <div className="mission__content">
            {!desc ? null : <p className="mission__desc">{desc}</p>}
            {!form.btnLabel || !form.portalId || !form.formId || !form.region || !form.id ? null : (
              <>
                <CustomButton
                  className="mission__cta btn"
                  type="button"
                  onClick={openModal}
                  ref={btnRef}
                  id={slugify(`${slug}-${form.formId}`)}
                >
                  {form.btnLabel}
                </CustomButton>
                {modal({
                  children: (
                    <>
                      <CustomButton
                        className="modal__close"
                        onClick={close}
                        type="button"
                        id={slugify(`${slug}-${form.formId}-modal-close`)}
                      >
                        <Icon.Plus className="icon-large" />
                        <span className="sr-only">Close modal</span>
                      </CustomButton>
                      <HubSpotForm
                        portalId={form.portalId}
                        formId={form.formId}
                        region={form.region}
                        id={form.id}
                      />
                    </>
                  ),
                  keepMounted: true,
                })}
              </>
            )}
          </div>
          <div className="mission__usps">
            {usps.map((usp, i) => (
              <div className="mission__usp h4" key={usp.title}>
                <span className="mission__usp-numb">{i + 1}</span>
                {usp.title}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Mission;
